import Vue from 'vue'
import Vuetify from 'vuetify/lib'
import no from 'vuetify/es5/locale/no'

Vue.use(Vuetify)

export default new Vuetify({
    theme: {
        dark: true,
        themes: {
            light: {
                primary: "#9C27B0",
                secondary: "#607D8B",
                accent: "#FF5722",
                error: "#F44336",
                warning: "#009688",
                info: "#8BC34A",
                success: "#4CAF50"
            },
            dark: {
                primary: "#9C27B0",
                secondary: "#607D8B",
                accent: "#FF5722",
                error: "#F44336",
                warning: "#009688",
                info: "#8BC34A",
                success: "#4CAF50"
            },
        },
    },
    lang: {
        locales: {no},
        current: 'no',
    },
    icons: {
        iconfont: 'fa',
    },
})
